import { axiosInstance } from './config_axios'

export const swrConfig = {
  fetcher: async (path: string, params: any) => {
    const response = await axiosInstance.get(path, { params })
    return response.data
  },
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
}
